import Vue from 'vue';

import { removeExtraSpaces } from '@/helpers/StringHelpers';

// S'occupe de retirer tous les espaces redoublés
const RemoveExtraSpaces = Vue.directive('remove-extra-spaces', {
  update(el) {
    const sourceValue = el.value;
    const newValue = removeExtraSpaces(sourceValue);

    if (sourceValue !== newValue) {
      const position = el.selectionStart;
      el.value = newValue;
      el.selectionEnd = position - 1;
      el.dispatchEvent(new Event('input'), { bubbles: true });
    }
  },
});

export default RemoveExtraSpaces;
